// extracted by mini-css-extract-plugin
export var facebook = "share-buttons-module--facebook--925a4";
export var shareButtons = "share-buttons-module--shareButtons--36e22";
export var twitter = "share-buttons-module--twitter--27f2f";